import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  addFacilityLoading: false,
  facilities: [],
  loginFacility: [],
  facilityTypes: [],
  allFacilities: [],
  allDeletedFacilities: [],
  allFacilityTypes: [],
};

export const facilityState = createSlice({
  name: "facility",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload,
      };
    },
    setLoadingAddFacility(state, action) {
      return {
        ...state,
        addFacilityLoading: action?.payload,
      };
    },
    setFacilities(state, action) {
      return {
        ...state,
        loading: false,
        facilities: action?.payload,
        addFacilityLoading: false,
      };
    },
    setLoginFacility(state, action) {
      return {
        ...state,
        loading: false,
        loginFacility: action?.payload?.ftypes,
        addFacilityLoading: false,
      };
    },
    setFacilityTypes(state, action) {
      return {
        ...state,
        loading: false,
        addFacilityLoading: false,
        facilityTypes: action?.payload,
      };
    },

    setAllFacilities(state, action) {
      return {
        ...state,
        loading: false,
        allFacilities: action?.payload,
        addFacilityLoading: false,
      };
    },
    setAllDeletedFacilities(state, action) {
      return {
        ...state,
        loading: false,
        allDeletedFacilities: action?.payload,
        addFacilityLoading: false,
      };
    },
    setAllFacilityTypes(state, action) {
      return {
        ...state,
        loading: false,
        addFacilityLoading: false,
        allFacilityTypes: action?.payload,
      };
    },

    // Reset State
    reset() {
      return initialState;
    },
  },
});


export const {
  setLoading,
  setFacilities,
  setLoginFacility,
  setLoadingAddFacility,
  setFacilityTypes,
  setAllDeletedFacilities,
  setAllFacilityTypes,
  setAllFacilities,
} = facilityState.actions;
export default facilityState.reducer;
